module.exports = __webpack_public_path__ + "img/LOGOfooter.6f21e197.png";